<template>
    <div class="wb-navbar-circle-button-color-container">
        <div class="wb-navbar-circle-button" v-on:click.stop="method()"
             :title="tooltip"
             :class="{'pressed': isPressed,'wb-navbar-circle-button-disabled': disabled}">
            <slot name="svg"></slot>
        </div>
        <div class="wb-navbar-circle-button-color-demo-anchor">
            <div class="wb-navbar-circle-button-color-demo"
                 :style="{'background': preview}">
                    <div class="wb-navbar-circle-button-color-tooltip">
                        <div class="wb-navbar-circle-button-color-tooltip-img-container">
                            <div class="wb-navbar-circle-button-color-tooltip-img"
                                 :style="{'background': preview}"></div>
                        </div>
                        <div class="wb-navbar-circle-button-color-tooltip-text">{{text}}</div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getImageHandler } from '@/lib/getImage';

export default {
    name: 'NavbarCircleButtonColor',
    methods: { getImageHandler },
    props: [
        'isPressed',
        'method',
        'param',
        'disabled',
        'tooltip',
        'previewProp',
        'nameProp',
    ],
  computed: {
        preview() {
            if (this.previewProp) {
                if (this.previewProp.charAt(0) === '#') {
                    return this.previewProp;
                } else {
                    return 'url(' + getImageHandler(this.previewProp) + ')';
                }
            }
            return '#FFFFFF';
        },
        text() {
            if (this.nameProp) {
                return this.nameProp;
            }
            return 'Не выбрано';
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";

.pressed{
  color: $green1 !important;;
  background-color: $white !important;;
}

.wb-navbar-circle-button-color-container {
    width: max-content;
    height: max-content;
    display: flex;
    flex-direction: row;
}

.wb-navbar-circle-button {
    @include wb-c-flex-center;
    color: $darkBlue;
    background-color: $gray2;
    height: 48px;
    width: 48px;
    border-radius: 24px;
    cursor: pointer;
    user-select: none;
    @include button-smooth;
}

.wb-navbar-circle-button:hover {
    background-color: $white;
}

//.wb-navbar-circle-button:active {
//    color: $green1;
//    background-color: $white;
//}

.wb-navbar-circle-button-disabled {
    color: $darkBlue !important;
    background-color: $gray2 !important;
    cursor: not-allowed !important;
}

.wb-navbar-circle-button-color-demo-anchor {
    position: relative;
    width: 0;
}

.wb-navbar-circle-button-color-demo {
    position: absolute;
    width: 20px;
    height: 20px;
    border: 2px solid $white;
    border-radius: 10px;
    background-color: $gray2;
    box-sizing: border-box;
    left: -20px;
    cursor: help;
}

.wb-navbar-circle-button-color-demo:hover .wb-navbar-circle-button-color-tooltip{
    display: grid;
}

.wb-navbar-circle-button-color-tooltip {
    @include button-smooth;
    position: absolute;
    border-radius: 4px;
    border: 1px solid $gray2;
    box-sizing: border-box;
    min-width: 88px;
    height: max-content;
    display: none; // grid
    grid-template-rows: max-content max-content;
    grid-row-gap: 10px;
    background-color: $white;
    justify-content: center;
    overflow: visible;
    left: 10px;
    top: 10px;
    padding: 8px;
    z-index: 21;
}

.wb-navbar-circle-button-color-tooltip:hover {
    display: grid;
}

.wb-navbar-circle-button-color-tooltip-img-container {
    @include wb-c-flex-center;
}

.wb-navbar-circle-button-color-tooltip-img {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    background: $gray2;
}

.wb-navbar-circle-button-color-tooltip-text {
    @include font-t2;
    text-align: center;
    width: 100%;
}

</style>
